export default "__VITE_ASSET__B3YmLQN3__"